import { render } from "./AssessmentResults.vue?vue&type=template&id=748a9560&scoped=true"
import script from "./AssessmentResults.vue?vue&type=script&lang=js"
export * from "./AssessmentResults.vue?vue&type=script&lang=js"

import "./AssessmentResults.vue?vue&type=style&index=0&id=748a9560&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748a9560"]])

export default __exports__